import { isEqual } from 'lodash-es';
import { useContext } from 'react';

import { useStoreSelector } from '../../../../core/store/selector.js';
import { TimeseriesChartStateContext } from '../../context/TimeseriesChartState.context.js';
import type { TimeseriesChartState } from '../../types/state.js';

export const useSelector = <T>(
  selector: (state: TimeseriesChartState) => T,
  compareFn?: (a: T, b: T) => boolean,
): T => useStoreSelector(TimeseriesChartStateContext, selector, compareFn);

export const useZoomState = () => useSelector((state) => state.zoom);

export const useAnnotationsState = () =>
  useSelector((state) => state.annotations);

export const useThresholdsState = () =>
  useSelector((state) => state.thresholds);

export const useFilteredSeriesIdsState = () =>
  useSelector((state) => state.filteredSeriesIds);

export const useHighlightedSeriesIdState = () =>
  useSelector((state) => state.highlightedSeriesId);

export const useCurrentDomainState = () =>
  useSelector((state) => state.currentDomain);

export const useInteractionModeState = () =>
  useSelector((state) => state.interactionMode);

export const useExploreState = () =>
  useSelector((state) => state.explore, isEqual);

export const useSelectState = () => useSelector((state) => state.select);

export const useSetState = () => {
  const { setState } = useContext(TimeseriesChartStateContext);

  return setState;
};
